import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const SchM3Form1065 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule M-3 (Form 1065): Complete Reconciliation Guide"
          description="Schedule M-3 (Form 1065) required for partnerships with $10M+ assets. Learn four-column book-to-tax reconciliation, filing triggers, and compliance rules."
          keywords=""
          canonical="resources/business-tax/schedule-m-3-form-1065/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          Form 1065{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule M-3:</span>
          </span>{' '}
          Net Income (Loss) Reconciliation for Certain Partnerships
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          {process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' && (
            <DynamicBreadcrumbs />
          )}
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-m-3-form-1065/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href="https://www.taxzerone.com/"
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule M-3 (Form 1065) at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <data
                        itemProp="position"
                        value="1"
                        style={{ display: 'none' }}
                      />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must file Schedule M-3,
                        </strong>{' '}
                        including the IRS filing thresholds based on total
                        assets, adjusted total assets, gross receipts, and
                        Reportable Entity Partner (REP) ownership, along with
                        voluntary filing rules.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <data
                        itemProp="position"
                        value="2"
                        style={{ display: 'none' }}
                      />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule M-3
                        </strong>{' '}
                        with detailed explanations of Part I, Part II, and Part
                        III, including financial information, income
                        reconciliation, expense reconciliation, and the
                        four-column reporting method for temporary and permanent
                        differences.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <data
                        itemProp="position"
                        value="3"
                        style={{ display: 'none' }}
                      />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand how Schedule M-3 connects with Form 1065,
                        </strong>{' '}
                        Schedule M-1, Schedule K, Schedule C, and other related
                        tax forms, while learning the required reconciliation
                        (tie-out) rules and reporting requirements.
                      </span>
                    </li>
                  </Box>
                </Box>

                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Large partnerships that meet IRS filing thresholds must
                      use{' '}
                      <strong style={{ fontWeight: 600 }}>
                        Schedule M-3 (Form 1065)
                      </strong>{' '}
                      to provide a detailed reconciliation of book income and
                      taxable income. Unlike Schedule M-1, Schedule M-3 requires
                      line-by-line reporting of temporary and permanent
                      differences, giving the IRS greater transparency into a
                      partnership's tax reporting.
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 3 }}>
                      This guide explains{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Schedule M-3 instructions
                      </strong>
                      , who must file Schedule M-3, how each part works, how it
                      differs from{' '}
                      <Link
                        href="/resources/business-tax/schedule-m-1-form-1065/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Schedule M-1
                      </Link>
                      , and how it fits into the overall{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1065-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1065
                      </Link>{' '}
                      filing process.
                    </Typography>
                  </Box>
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is Schedule M-3 Form 1065?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#four" sx={{ color: '#0202ff' }}>
                          The Four Columns of Schedule M-3 (Parts II and III)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Schedule M-3 (Form 1065)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#voluntary" sx={{ color: '#0202ff' }}>
                          Voluntary Filing of Schedule M-3
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#completing" sx={{ color: '#0202ff' }}>
                          Completing Schedule M-3: The $50 Million Asset
                          Threshold Rule
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#line" sx={{ color: '#0202ff' }}>
                          Line-by-line instruction for Schedule M-3
                        </Link>
                        <List sx={{ pb: 0 }}>
                          <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part1" sx={{ color: '#0202ff' }}>
                                Schedule M-3 Part I: Financial Information and
                                Net Income (Loss) Reconciliation
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part2" sx={{ color: '#0202ff' }}>
                                Schedule M-3 Part II: Income Item Reconciliation
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part3" sx={{ color: '#0202ff' }}>
                                Schedule M-3 Part III: Expense and Deduction
                                Item Reconciliation
                              </Link>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#critical" sx={{ color: '#0202ff' }}>
                          Critical Tie-Outs: How Schedule M-3 Must Reconcile
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#schm3" sx={{ color: '#0202ff' }}>
                          Schedule M-3 vs. Schedule M-1: Side-by-Side Comparison
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#division" sx={{ color: '#0202ff' }}>
                          Schedule M-3 and the IRS Large Business &
                          International Division
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#schc" sx={{ color: '#0202ff' }}>
                          Schedule M-3 and Schedule C (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#reportable" sx={{ color: '#0202ff' }}>
                          Reportable Entity Partner (REP): A Detailed Look
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#errors" sx={{ color: '#0202ff' }}>
                          Common Errors to Avoid on Schedule M-3
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key IRS Resources for Schedule M-3 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What Is Schedule M-3 (Form 1065)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M-3 is a multi-part supplemental schedule attached to{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 1065
                  </Link>{' '}
                  that reconciles a partnership's{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    financial statement net income (loss)
                  </span>{' '}
                  with its{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    taxable income (loss) per the return
                  </span>
                  . It is the large-partnership equivalent of the simpler{' '}
                  <Link
                    href="/resources/business-tax/schedule-m-1/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule M-1
                  </Link>{' '}
                  used by smaller partnerships, but with significantly more
                  depth and transparency.
                </Typography>
                <Typography variant="body1">
                  The schedule is organized into three parts:
                </Typography>

                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Part I —</span> Financial
                    Information and Net Income (Loss) Reconciliation: Identifies
                    the type of financial statements the partnership prepares,
                    reconciles consolidated financial statement income to the
                    partnership's own book income, and arrives at the
                    partnership's net income (loss) per its own income
                    statement.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Part II — </span>{' '}
                    Reconciliation of Net Income (Loss) per Income Statement
                    with Income (Loss) per Return — Income Items: Line-by-line
                    reconciliation of income and gain items.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Part III —</span>{' '}
                    Reconciliation of Net Income (Loss) per Income Statement
                    with Income (Loss) per Return — Expense/Deduction Items:
                    Line-by-line reconciliation of expense and deduction items.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Each line in Parts II and III uses{' '}
                  <span style={{ fontWeight: 600 }}> four columns</span> — A
                  through D — to classify every income or expense item
                  precisely.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="four"
                >
                  The Four Columns of Schedule M-3 (Parts II and III)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The column structure is the most important feature of Schedule
                  M-3 and is what distinguishes it from the simpler Schedule
                  M-1. Every income and expense line in Parts II and III must be
                  reported across all four columns:
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Column
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Label
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            What It Represents
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Column A
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Income (Loss) per Income Statement
                          </TableCell>

                          <TableCell>
                            The amount as recorded in the partnership's
                            financial statements (GAAP or other basis)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Column B
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Temporary Difference
                          </TableCell>

                          <TableCell>
                            {' '}
                            The portion of the difference between Column A and
                            Column D that will reverse in a future year
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Column C
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Permanent Difference
                          </TableCell>

                          <TableCell>
                            The portion of the difference that will never
                            reverse — a lasting divergence between book and tax
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Column D
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Income (Loss) per Tax Return
                          </TableCell>

                          <TableCell>
                            {' '}
                            The taxable amount that flows into the partnership's
                            Form 1065 and ultimately to{' '}
                            <Link
                              href="/resources/business-tax/schedule-k/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Schedule K
                            </Link>{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}> The math:</span> Column A +
                  Column B + Column C = Column D. For every line, the sum of the
                  temporary and permanent differences, added to or subtracted
                  from the book amount, must produce the tax return amount.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This four-column structure forces the partnership to
                  explicitly identify and label every book-to-tax difference as
                  either a timing issue (temporary) or a lasting divergence
                  (permanent) — a level of specificity the IRS uses to evaluate
                  compliance risk and identify audit targets.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Schedule M-3 (Form 1065)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  According to the IRS Instructions for Schedule M-3 (Form
                  1065),{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    any entity filing Form 1065 must file Schedule M-3 if any
                    one of the following four conditions is true:
                  </span>
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Condition 1 — Total Assets of $10 Million or More
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The amount of total assets at the end of the tax year reported
                  on{' '}
                  <Link
                    href="/resources/business-tax/schedule-l/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule L
                  </Link>
                  , Line 14, Column (d), equals or exceeds{' '}
                  <span style={{ fontWeight: 600 }}> $10 million</span>.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Condition 2 — Adjusted Total Assets of $10 Million or More
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    adjusted total assets
                  </span>{' '}
                  for the tax year equal or exceed{' '}
                  <span style={{ fontWeight: 600 }}>$10 million</span>. Adjusted
                  total assets are calculated using a specific IRS worksheet
                  that modifies the Schedule L balance sheet figure to account
                  for:
                </Typography>
                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>Distributions made during the year</li>
                  <li>Net losses for the year </li>
                  <li>Certain other adjustments</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This prevents partnerships from avoiding the Schedule M-3
                  requirement by making large distributions just before year-end
                  to reduce their reported asset balance.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Condition 3 — Total Receipts of $35 Million or More
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The total receipts for the tax year equal or exceed{' '}
                  <span style={{ fontWeight: 600 }}>$35 million</span>. Total
                  receipts is defined as gross receipts or sales (net of returns
                  and allowances), plus all other income reported on Form 1065,
                  including interest, dividends, rents, royalties, and capital
                  gains.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Condition 4 — Reportable Entity Partner Ownership of 50% or
                  More
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  A{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Reportable Entity Partner (REP)
                  </span>{' '}
                  owns or is deemed to own, directly or indirectly, a 50% or
                  greater interest in the partnership's income, loss, or capital
                  on <span style={{ fontWeight: 600 }}> any day</span> during
                  the tax year — and that REP was itself required to file
                  Schedule M-3 on its most recently filed U.S. income tax return
                  prior to that day.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This condition creates a cascading requirement: if a large
                  corporate partner that files Schedule M-3 owns 50% or more of
                  a partnership, that partnership is also pulled into the
                  Schedule M-3 filing requirement — even if it would not
                  otherwise meet the asset or receipts thresholds on its own.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Summary of Filing Triggers
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Trigger
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Threshold
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Total assets (Schedule L, Line 14){' '}
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>
                            {' '}
                            $10 million or more
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Adjusted total assets
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>
                            {' '}
                            $10 million or more
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Total receipts
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>
                            {' '}
                            $35 million or more
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Reportable Entity Partner ownership
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>
                            {' '}
                            50% or more interest on any day{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Meeting <span style={{ fontWeight: 600 }}> any one</span> of
                  these four conditions requires the partnership to file
                  Schedule M-3. All four do not need to be satisfied
                  simultaneously.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="vouluntary"
                >
                  Voluntary Filing of Schedule M-3
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Partnerships that do{' '}
                  <span style={{ fontWeight: 600 }}> not</span> meet any of the
                  four filing triggers above may still{' '}
                  <span style={{ fontWeight: 600 }}> voluntarily</span> file
                  Schedule M-3 in place of{' '}
                  <Link
                    href="/resources/business-tax/schedule-m-1/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule M-1
                  </Link>
                  . Some partnerships choose this route to maintain reporting
                  consistency with related entities in a consolidated group, or
                  to provide greater transparency to partners or lenders who
                  review the tax return.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="completing"
                >
                  Completing Schedule M-3: The $50 Million Asset Threshold Rule
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The level of completion required for Schedule M-3 depends on
                  whether the partnership has{' '}
                  <span style={{ fontWeight: 600 }}> $50 million or more</span>{' '}
                  in total assets at year-end:
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Partnerships With $50 Million or More in Total Assets
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  These partnerships must
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    complete Schedule M-3 in its entirety —
                  </span>{' '}
                  all three parts and all four columns for every applicable line
                  item.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Partnerships With Less Than $50 Million in Total Assets (But
                  Required to File M-3)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  These partnerships, as well as those voluntarily filing
                  Schedule M-3, have two options:
                </Typography>

                <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Complete Schedule M-3 in its entirety (all three parts), OR
                  </li>
                  <li>
                    Complete only{' '}
                    <span style={{ fontWeight: 600 }}> Part I</span> of Schedule
                    M-3, and then complete{' '}
                    <Link
                      href="/resources/business-tax/schedule-m-1/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule M-1
                    </Link>{' '}
                    instead of Parts II and III.
                  </li>
                </Box>
                <Alert
                  icon={false}
                  severity="info"
                  sx={{ mt: 0, mb: 3, borderLeft: '3px solid #0288d1' }}
                >
                  <b>Important :</b> If a partnership chooses Option 2, Line 1
                  of Schedule M-1 must equal Line 11 of Schedule M-3, Part I.
                  The two schedules must link precisely.
                </Alert>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="Line"
                >
                  Line by line instruction for Schedule M-3
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Before completing Schedule M-3, partnerships must indicate the
                  reason the schedule is being filed. Check all applicable boxes
                  that apply to your partnership's financial situation during
                  the tax year.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Filing Requirements and Applicable Checkboxes
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-f1065-img.webp" />
                  <source srcSet="/assets/images/schm-3-f1065-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-f1065-img.png"
                    loading="lazy"
                    alt="Schedule M-3 Form 1065 filing requirements and applicable checkboxes section"
                    width={760}
                    height={324}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Name of Partnership
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the legal name of the partnership exactly as it appears
                  on Form 1065.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Employer Identification Number (EIN)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the nine-digit EIN issued by the IRS for the
                  partnership. It must match what IRS has on file so there are
                  no processing delays.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box A – Total Assets Test
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check <strong style={{ fontWeight: 600 }}> Box A</strong> if
                  the partnership's total assets at the end of the tax year are
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    $10 million or more.
                  </strong>
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box B – Adjusted Total Assets Test
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Check <strong style={{ fontWeight: 600 }}> Box B </strong> if
                  the partnership's adjusted total assets at the end of the tax
                  year are{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    $10 million or more
                  </strong>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong style={{ fontWeight: 600 }}> Enter</strong> the
                  partnership's adjusted total assets for the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box C – Gross Receipts Test
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Check <strong style={{ fontWeight: 600 }}> Box C</strong> if
                  the partnership's total receipts for the tax year are{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    $35 million or more
                  </strong>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong style={{ fontWeight: 600 }}> Enter</strong> the
                  partnership's total receipts for the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box D – Reportable Entity Partner
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Check <strong style={{ fontWeight: 600 }}> Box D</strong> if a
                  reportable entity partner owns, or is deemed to own,{' '}
                  <strong style={{ fontWeight: 600 }}> 50% or more</strong> of
                  the partnership's capital, profits, or losses at any time
                  during the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  If checked, provide
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead />
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ borderRight: '1px solid #828282' }}>
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Name of Reportable Entity Partner
                            </strong>
                          </TableCell>

                          <TableCell>
                            Enter the legal name of the reportable entity
                            partner.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ borderRight: '1px solid #828282' }}>
                            {' '}
                            <strong style={{ fontWeight: 600 }}>
                              Identifying Number
                            </strong>
                          </TableCell>

                          <TableCell>
                            Enter the partner's EIN or other identifying number.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ borderRight: '1px solid #828282' }}>
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Maximum Percentage Owned or Deemed Owned
                            </strong>{' '}
                          </TableCell>

                          <TableCell>
                            Enter the highest ownership percentage held during
                            the tax year.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box E – Voluntary Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check <strong style={{ fontWeight: 600 }}> Box E</strong> if
                  you are filing Schedule M-3 voluntarily, even though you are
                  not required to file it.
                </Typography>
                <Alert
                  severity="info"
                  id="who"
                  icon={false}
                  sx={{
                    mb: 4,
                    borderLeft: '3px solid #0288d1',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Filing Tip:</b> You may need to check more than one box if
                  multiple filing requirements apply to your partnership. Review
                  each condition carefully before submitting Schedule M-3 with
                  Form 1065.
                </Alert>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="part1"
                >
                  Schedule M-3 Part I: Financial Information and Net Income
                  (Loss) Reconciliation
                </Typography>
                <Typography variant="body1">
                  Part I is the foundation of Schedule M-3. It establishes the
                  starting point for the entire reconciliation by identifying
                  the type of financial statements the partnership prepares and
                  working from the most comprehensive (consolidated/worldwide)
                  financial income down to the partnership's own standalone book
                  income.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 1 — Type of Income Statement Prepared
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part1-img.webp" />
                  <source srcSet="/assets/images/schm-3-part1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part1-img.png"
                    loading="lazy"
                    alt="Section (Lines A–K) + Income Section (Lines 1a–8) "
                    width={760}
                    height={287}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 0,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  The partnership must indicate the highest-priority type of
                  financial statement it prepares. The IRS establishes the
                  following order of priority:
                </Typography>
                <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    SEC 10-K or Annual Statement filed with a Federal or State
                    agency
                  </li>
                  <li>Certified Audited Non-Tax-Basis Financial Statements </li>
                  <li>Non-Tax-Basis Financial Statements — Other</li>
                  <li>Tax-Basis Financial Statements</li>
                  <li>No Financial Statements Prepared</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  The type selected on Line 1 governs what goes into Column A
                  throughout Parts II and III. A partnership that prepares GAAP
                  financial statements uses GAAP income as its Column A basis. A
                  partnership that only prepares tax-basis records uses those
                  records.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 2 — Enter the Income Statement Period
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the{' '}
                  <strong style={{ fontWeight: 600 }}> beginning</strong> and
                  <strong style={{ fontWeight: 600 }}> ending</strong> dates of
                  the income statement used to prepare Schedule M-3. The period
                  should generally match the financial statements used for tax
                  reporting.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 3a — Current Period Restatement
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Select Yes if the income statement for the period on Line 2
                  has been restated.{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If yes, attach a statement explaining the reason for the
                  restatement and the amount of each item restated. Otherwise,
                  select No.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 3b — Prior Five-Year Restatements{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Indicate whether the partnership restated its income statement
                  for any of the five immediately preceding income statement
                  periods.{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If yes, attach a statement describing each restatement and the
                  related amounts. Otherwise, select No.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 4 — Worldwide Consolidated Net Income (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part1-line4-img.webp" />
                  <source srcSet="/assets/images/schm-3-part1-line4-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part1-line4-img.png"
                    loading="lazy"
                    alt="Schedule M-3 Form 1065 Part I financial information and net income reconciliation lines 4 through 11"
                    width={760}
                    height={274}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 0,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the partnership is part of a broader consolidated financial
                  reporting group, Line 4 captures the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    worldwide consolidated net income (loss)
                  </span>{' '}
                  per the consolidated financial statements — the broadest
                  possible starting point.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 5a — Net Income from Nonincludible Foreign Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the net income of nonincludible foreign entities
                  included in the partnership’s financial statement income.
                  Attach a statement with the entity name, EIN (if applicable),
                  and income amount removed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 5b — Net Loss from Nonincludible Foreign Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the net loss of nonincludible foreign entities as a
                  positive amount. Attach a statement with the entity details
                  and loss amount removed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 6a — Net Income from Nonincludible U.S. Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the net income of nonincludible U.S. entities included
                  in the partnership’s financial statement income. Attach a
                  statement with the entity name, EIN (if applicable), and
                  income amount removed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 6b — Net Loss from Nonincludible U.S. Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the net loss of nonincludible U.S. entities as a
                  positive amount. Attach a statement with the entity details
                  and loss amount removed.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Lines 7a and 7b — Disregarded Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  These lines address the income or loss of{' '}
                  <span style={{ fontWeight: 600 }}> disregarded entities</span>{' '}
                  (entities that are not treated as separate for tax purposes)
                  that are either included in or excluded from the partnership's
                  financial statements.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 8 — Intercompany Eliminations
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Adjustments are made here to reflect or reverse eliminations
                  of intercompany transactions between includible and
                  nonincludible entities — ensuring the partnership's book
                  income figure is stated correctly on a standalone basis.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 9 — Period Adjustment
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the partnership's financial statement period differs from
                  its tax year (for example, a fiscal-year partnership whose
                  financials cover a different period), Line 9 reconciles the
                  timing difference.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 10 — Other Adjustments
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Any remaining adjustments needed to arrive at the
                  partnership's standalone book income are reported here, with a
                  supporting statement attached.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 11 — Net Income (Loss) per Income Statement of the
                  Partnership
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This is the key output of Part I — the partnership's
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    standalone book net income (loss).
                  </span>{' '}
                  This figure flows into Parts II and III as the starting point
                  for Column A income and expense reconciliation. It must also
                  match Line 1 of{' '}
                  <Link
                    href="/resources/business-tax/schedule-m-1/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule M-1
                  </Link>{' '}
                  if the partnership completes M-1 in lieu of Parts II and III.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 12 – Total Assets and Liabilities of Entities Included or
                  Removed on Part I, Lines 4–7
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part1-line12-img.webp" />
                  <source srcSet="/assets/images/schm-3-part1-line12-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part1-line12-img.png"
                    loading="lazy"
                    alt="Total assets and liabilities of entities included or removed on Schedule M-3 Form 1065"
                    width={760}
                    height={99}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  All partnerships filing Schedule M-3 must complete Line 12.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report the total assets and total liabilities of all entities
                  included or removed on Part I, Lines 4, 5, 6, and 7. Enter the
                  total amount. Do not enter partnership ownership share. All
                  amounts should be expressed as positive numbers.
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Line 12a:</strong>{' '}
                    Total assets and liabilities of entities included in Part I,
                    Line 4.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Line 12b:</strong>{' '}
                    Total assets and liabilities of entities removed on Part I,
                    Line 5.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Line 12c:</strong>{' '}
                    Total assets and liabilities of entities removed on Part I,
                    Line 6.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Line 12d:</strong>{' '}
                    Total assets and liabilities of entities included in Part I,
                    Line 7.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  For Line 12a, report on the worldwide consolidated total
                  assets and liabilities of all entities included in Part I,
                  Line 4.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="part2"
                >
                  Schedule M-3 Part II: Income Item Reconciliation
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part2-img.webp" />
                  <source srcSet="/assets/images/schm-3-part2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part2-img.png"
                    loading="lazy"
                    alt="Part II reconciliation of net income (loss) per income statement with income (loss) per return on Schedule M-3 Form 1065 (Lines 1 to 20)"
                    width={760}
                    height={432}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Part II reconciles all{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    income and gain items
                  </span>{' '}
                  between the partnership's financial statements and its tax
                  return, line by line, across all four columns. Key lines
                  include:
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Lines 1–9 — Additional Information for Each Entity
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Attach a supporting statement for each applicable line. Enter
                  the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    name of the entity, EIN (if applicable), type of entity, and
                    the amounts
                  </span>{' '}
                  reported in columns (a) through (d) Additional information may
                  be needed for some lines.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Lines 1–9 — Pass-Through and Investment Income:
                  </span>{' '}
                  These lines address income from equity method investments in
                  foreign corporations, foreign dividends, Subpart F inclusions,
                  equity method income from U.S. corporations, U.S. dividends,
                  income from domestic and foreign partnerships, and income from
                  other pass-through entities. These items often carry
                  significant book-to-tax differences because GAAP equity method
                  accounting and U.S. tax law treat investment income very
                  differently.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 1 — Income (Loss) From Equity Method Foreign Corporations
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report the financial income (loss) from foreign corporations
                  accounted for using the equity method in{' '}
                  <span style={{ fontWeight: 600 }}> column (a)</span>. Remove
                  the amount in{' '}
                  <span style={{ fontWeight: 600 }}>column (b)</span> or{' '}
                  <span style={{ fontWeight: 600 }}> (c)</span>, as applicable.
                  Report related dividends or taxable foreign income on{' '}
                  <span style={{ fontWeight: 600 }}> Lines 2–4</span>.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 2 — Gross Foreign Dividends Not Previously Taxed
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report foreign dividends that have{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    not been previously taxed.
                  </span>{' '}
                  Enter the financial statement amount in{' '}
                  <span style={{ fontWeight: 600 }}> column (a)</span> and the
                  taxable amount in{' '}
                  <span style={{ fontWeight: 600 }}>column (d)</span>. Do not
                  include previously taxed distributions or Subpart F/QEF
                  income.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 3 — Subpart F, QEF, and Similar Income Inclusions
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report taxable income from{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Subpart F, Qualified Electing Funds (QEFs), Passive Foreign
                    Investment Companies (PFICs)
                  </span>
                  , and similar foreign income inclusions in{' '}
                  <span style={{ fontWeight: 600 }}> column (d)</span>.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 4 — Gross Foreign Distributions Previously Taxed
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report previously taxed foreign distributions in{' '}
                  <span style={{ fontWeight: 600 }}> column (a)</span>
                  and remove them in{' '}
                  <span style={{ fontWeight: 600 }}> column (b)</span> or{' '}
                  <span style={{ fontWeight: 600 }}> (c)</span>, as applicable.
                  Since these amounts are not currently taxable, column (d) is
                  not completed.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 5 — Income (Loss) From Equity Method U.S. Corporations
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report financial income (loss) from U.S. corporations
                  accounted for using the equity method in{' '}
                  <span style={{ fontWeight: 600 }}>column (a)</span>. Remove
                  the amount in{' '}
                  <span style={{ fontWeight: 600 }}> column (b)</span> or{' '}
                  <span style={{ fontWeight: 600 }}> (c)</span>, as applicable.
                  Report related dividends on Line 6.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 6 — U.S. Dividends
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report U.S. corporation dividends included in the financial
                  statements in{' '}
                  <span style={{ fontWeight: 600 }}> column (a)</span> and the
                  taxable dividends in{' '}
                  <span style={{ fontWeight: 600 }}> column (d)</span>. Attach
                  additional information if the partnership owned{' '}
                  <span style={{ fontWeight: 600 }}>10% or more</span> of the
                  voting stock.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 7 — Income (Loss) From U.S. Partnerships
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report the partnership's share of income or loss from U.S.
                  partnerships in{' '}
                  <span style={{ fontWeight: 600 }}> columns (a)–(d)</span>,
                  including any temporary or permanent differences. Attach a
                  supporting statement for each partnership.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 8 — Income (Loss) From Foreign Partnerships
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report the partnership's share of income or loss from foreign
                  partnerships using the same reporting method as{' '}
                  <span style={{ fontWeight: 600 }}> Line 7</span>. Attach a
                  supporting statement for each foreign partnership.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 9 — Income (Loss) From Other Pass-Through Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report income or loss from pass-through entities other than
                  partnerships (excluding disregarded entities). Include any
                  reconciliation differences and attach a supporting statement
                  for each entity.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note :</b> For Lines{' '}
                  <span style={{ fontWeight: 600 }}> 2, 6, 7, 8, and 9,</span>{' '}
                  additional supporting details may be required, such as
                  ownership percentage, dividend payer information, or Schedule
                  K-1 amounts, depending on the type of entity.
                </Alert>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 11 — Interest Income:
                  </span>{' '}
                  Interest income differences between book and tax are common,
                  particularly for partnerships using the accrual method or
                  holding debt instruments subject to original issue discount
                  (OID) rules.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 12 — Total Accrual to Cash Adjustment:
                  </span>{' '}
                  For partnerships that maintain books on the accrual method but
                  file on the cash method — or vice versa — the aggregate timing
                  difference between the two methods is captured here.
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 13 — Hedging Transactions:
                  </span>{' '}
                  Gain or loss from hedging transactions (such as interest rate
                  swaps or foreign currency hedges) may be treated differently
                  under GAAP vs. the tax code, creating book-to-tax differences
                  that flow through Line 13.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 14 — Mark-to-Market Income (Loss):
                  </span>{' '}
                  Partnerships in securities or commodities trading that use
                  mark-to-market accounting under Section 475(f) recognize gains
                  and losses on a current-year basis for tax — which may differ
                  significantly from their GAAP financial statement treatment.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 15 — Cost of Goods Sold
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report amounts deducted as{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    cost of goods sold (COGS)
                  </span>{' '}
                  during the tax year, including inventory-related adjustments
                  such as inventory valuation, Section 263A costs, inventory
                  shrinkage, obsolescence reserves, and lower of cost or market
                  (LCM) write-downs.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 2,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note :</b> Complete{' '}
                  <span style={{ fontWeight: 600 }}> Form 8916-A, Part I,</span>{' '}
                  if required, and attach it to Schedule M-3.
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 16 — Sale Versus Lease (For Sellers and/or Lessors)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Use this line when a transaction is treated as a{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    sale for financial reporting{' '}
                  </span>{' '}
                  but as a{' '}
                  <span style={{ fontWeight: 600 }}>
                    lease for tax purposes,
                  </span>{' '}
                  or vice versa.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Report the financial statement amount in column (a).</li>
                  <li>Report the federal tax amount in column (d). </li>
                  <li>
                    Use columns (b) and (c) to report any temporary or permanent
                    differences.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 17 — Section 481(a) Adjustments
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Report any{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Section 481(a) adjustment
                  </span>{' '}
                  resulting from a change in accounting method, unless it is
                  required to be reported elsewhere on Schedule M-3.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Use the appropriate columns to report any temporary or
                  permanent differences.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 18 — Unearned/Deferred Revenue
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Report revenue recognized in different periods for{' '}
                  <span style={{ fontWeight: 600 }}> financial reporting</span>{' '}
                  and <span style={{ fontWeight: 600 }}> tax purposes.</span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Use <span style={{ fontWeight: 600 }}> columns (b)</span> and
                  <span style={{ fontWeight: 600 }}> (c)</span> to reconcile any
                  differences. Do <span style={{ fontWeight: 600 }}> not</span>{' '}
                  report income from long-term contracts on this line.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 19 — Income Recognition From Long-Term Contracts
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report income or loss from{' '}
                  <span style={{ fontWeight: 600 }}> long-term contracts</span>{' '}
                  recognized for financial statement purposes and federal income
                  tax purposes. Use the reconciliation columns to report any
                  differences.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 20 — Original Issue Discount (OID) and Other Imputed
                  Interest
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}>
                    Original Issue Discount (OID)
                  </span>{' '}
                  and other forms of{' '}
                  <span style={{ fontWeight: 600 }}> imputed interest</span>,
                  including amounts recognized under the applicable Internal
                  Revenue Code provisions. Use the reconciliation columns to
                  report any differences between book and tax amounts.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part2-line21-img.webp" />
                  <source srcSet="/assets/images/schm-3-part2-line21-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part2-line21-img.png"
                    loading="lazy"
                    alt="Schedule M-3 (Form 1065) Part II reconciliation of net income (loss) per income statement with income (loss) per return, lines 21–26"
                    width={760}
                    height={392}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Lines 21a–21g — Disposition of Assets:
                  </span>{' '}
                  A detailed sub-section captures every type of gain or loss
                  from dispositions of assets — including capital gains and
                  losses (Schedule D), Section 1231 gains and losses (
                  <Link
                    href="/resources/business-tax/form-4797/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 4797
                  </Link>
                  ), abandonment losses, and worthless stock losses — comparing
                  the book treatment to the tax return amounts across all four
                  columns.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 22 — Other Income Items With Differences:
                  </span>{' '}
                  A catch-all line for income items with book-to-tax differences
                  not covered by the specific lines above. A supporting
                  statement is required.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 26 — Income (Loss) per Return:
                  </span>{' '}
                  The final output of Part II, Column D — which must equal{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Line 1 of the Analysis of Net Income (Loss) on Form 1065 —
                  </span>{' '}
                  is one of the most critical tie-out points in the entire
                  return. If this number does not match, there is an error that
                  must be corrected before filing.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="part3"
                >
                  Schedule M-3 Part III: Expense and Deduction Item
                  Reconciliation
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Part III reconciles all{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    expense and deduction items
                  </span>{' '}
                  between the partnership's financial statements and its tax
                  return. It mirrors Part II's structure but focuses on the
                  expense side of the income statement. Key lines include:
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part3-img.webp" />
                  <source srcSet="/assets/images/schm-3-part3-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part3-img.png"
                    loading="lazy"
                    alt="Schedule M-3 (Form 1065) Part III reconciliation of net income expense and deduction items, lines 1–14"
                    width={760}
                    height={353}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Lines 1–4 — Income Tax Expense:
                  </span>{' '}
                  Federal, state, local, and foreign income tax expense recorded
                  on the books is typically not deductible at the federal level
                  for partnerships (since the partnership itself generally does
                  not pay income tax). These book expenses are permanent
                  differences that appear in Column C.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 5 — Equity-Based Compensation:
                  </span>{' '}
                  Stock options, restricted stock units, and other equity-based
                  compensation are often expensed for GAAP purposes when granted
                  or vested, but may be deductible for tax at a different time
                  or amount, creating both temporary and permanent differences.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 6 — Meals and Entertainment:
                  </span>{' '}
                  The IRS limits the deduction for meal expenses to{' '}
                  <span style={{ fontWeight: 600 }}>50%</span> of costs.
                  Entertainment expenses are generally fully non-deductible.
                  Book treatment is typically 100% of the cost. The
                  non-deductible portion is a permanent difference in Column C.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 7 — Fines and Penalties:
                  </span>{' '}
                  Fines and penalties paid to a government for violations of law
                  are permanently non-deductible under Section 162(f). Book
                  expense is recorded fully but must be backed out entirely in
                  Column C.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 8 — Judgments, Damages, Awards, and Similar Costs:
                  </span>{' '}
                  Settlements and damage awards may be fully deductible,
                  partially deductible, or non-deductible depending on their
                  nature. Restitution payments and disgorgement amounts ordered
                  by certain government authorities are non-deductible under
                  Section 162(f)(2).
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 9 — Guaranteed Payments:
                  </span>{' '}
                  <Link
                    href="/resources/business-tax/schedule-k/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Guaranteed payments
                  </Link>{' '}
                  to partners are deductible for tax purposes as business
                  expenses, but their treatment under GAAP may differ —
                  particularly in terms of timing.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 10 — Pension and Profit-Sharing:
                  </span>{' '}
                  Differences between the pension expense recorded under GAAP
                  (ASC 715) and the deductible contribution amount under the tax
                  code (which is generally limited to amounts actually funded)
                  create both temporary and permanent differences.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 11 — Other Post-Retirement Benefits:
                  </span>{' '}
                  GAAP requires accrual of post-retirement benefit obligations
                  (such as retiree medical benefits) as they are earned. The tax
                  deduction, however, generally arises only when these costs are
                  actually paid — a classic temporary difference.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 12 — Deferred Compensation:
                  </span>{' '}
                  Nonqualified deferred compensation under Section 409A may be
                  expensed for GAAP as it is earned, but is deductible for tax
                  only when it is actually paid and includible in the employee's
                  income — a timing difference that can span many years.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 13 – Charitable Contribution of Cash and Tangible
                  Property
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report charitable contributions of{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    cash and tangible property
                  </span>
                  . Enter the book expense in{' '}
                  <span style={{ fontWeight: 600 }}> column (a)</span> and the
                  deductible amount on the tax return in{' '}
                  <span style={{ fontWeight: 600 }}> column (d)</span>. Report
                  any book-to-tax differences in{' '}
                  <span style={{ fontWeight: 600 }}> columns (b)</span> or{' '}
                  <span style={{ fontWeight: 600 }}> (c)</span>.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 14 – Charitable Contribution of Intangible Property
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report charitable contributions of{' '}
                  <span style={{ fontWeight: 600 }}> intangible property,</span>{' '}
                  such as patents, copyrights, trademarks, securities,
                  conservation easements, mineral rights, and other intangible
                  assets.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schm-3-part3-line15-img.webp" />
                  <source srcSet="/assets/images/schm-3-part3-line15-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schm-3-part3-line15-img.png"
                    loading="lazy"
                    alt=" Schedule M-3 (Form 1065) Part III reconciliation of net income expense and deduction items, lines 15–31"
                    width={760}
                    height={435}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 15 – Organizational Expenses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    organizational expenses
                  </span>{' '}
                  as defined in{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Regulations section 1.709-2(a)
                  </span>
                  . Enter the book expense in{' '}
                  <span style={{ fontWeight: 600 }}> column (a)</span> and the
                  deductible amount under{' '}
                  <span style={{ fontWeight: 600 }}> section 709(b)</span> in{' '}
                  <span style={{ fontWeight: 600 }}> column (d)</span>.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 16 – Syndication Expenses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}> syndication expenses</span>{' '}
                  as defined in{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Regulations section 1.709-2(b)
                  </span>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 17 – Acquisition/Reorganization Investment Banking Fees
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}>
                    investment banking fees
                  </span>{' '}
                  paid or incurred for taxable or tax-free acquisitions or
                  reorganizations, including fees for evaluating, investigating,
                  or completing the transaction.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 18 – Acquisition/Reorganization Legal and Accounting Fees
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    legal and accounting fees
                  </span>{' '}
                  related to taxable or tax-free acquisitions or
                  reorganizations, including fees incurred during evaluation,
                  investigation, or completion of the transaction.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 19 – Amortization/Impairment of Goodwill
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    goodwill amortization
                  </span>{' '}
                  and any{' '}
                  <span style={{ fontWeight: 600 }}>
                    goodwill impairment losses
                  </span>{' '}
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 20 – Amortization of Acquisition, Reorganization, and
                  Start-up Costs
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    amortization of acquisition, reorganization, and start-up
                    costs
                  </span>
                  . Include amounts amortizable under sections 167 or 195, where
                  applicable.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 21 – Other Amortization or Impairment Write-Offs
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report any{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    other amortization or impairment write-offs
                  </span>{' '}
                  not reported elsewhere on Schedule M-3.
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Lines 23a and 23b — Depletion:
                  </span>{' '}
                  Partnerships in oil, gas, and mineral industries may claim
                  percentage depletion for tax purposes that exceeds cost
                  depletion recorded on the books, creating temporary
                  differences that can be substantial in resource-heavy
                  partnerships.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 24 — Intangible Drilling and Development Costs (IDC):
                  </span>{' '}
                  Oil and gas partnerships may elect to deduct IDC immediately
                  for tax purposes (Section 263(c)), while GAAP requires
                  capitalization and amortization — a significant timing
                  difference for energy partnerships.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 25 — Depreciation:
                  </span>{' '}
                  Depreciation differences are among the most common items on
                  Schedule M-3. Tax depreciation using MACRS, bonus depreciation
                  (Section 168(k)), and Section 179 expensing typically results
                  in larger early-year deductions than straight-line GAAP
                  depreciation. See{' '}
                  <Link
                    href="/resources/business-tax/form-4562/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 4562
                  </Link>{' '}
                  for how depreciation flows through the return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 26 — Bad Debt Expense:
                  </span>{' '}
                  GAAP requires an allowance for doubtful accounts (estimated
                  bad debts), while the tax code generally allows a deduction
                  only for <span style={{ fontWeight: 600 }}> specific </span>{' '}
                  bad debts that are actually charged off as worthless during
                  the year. This creates a recurring temporary difference for
                  partnerships with significant receivables.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 27 — Interest Expense:
                  </span>{' '}
                  Interest expense differences arise from various sources —
                  including Section 163(j) business interest expense
                  limitations, original issue discount rules, and differences in
                  the timing of interest accrual between GAAP and tax.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 28 — Purchase vs. Lease:
                  </span>{' '}
                  For partnerships that enter into transactions that are treated
                  as purchases for tax purposes but leases for GAAP (or vice
                  versa), this line captures the resulting income and expense
                  differences.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 29 — Research and Development Costs:
                  </span>{' '}
                  For tax years beginning after December 31, 2021, specified R&D
                  costs must be{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    capitalized and amortized{' '}
                  </span>{' '}
                  over five years (domestic) or fifteen years (foreign) for tax
                  purposes under the Tax Cuts and Jobs Act change to Section
                  174. This creates a significant difference from GAAP, which
                  continues to allow immediate expensing of R&D under ASC 730 in
                  most circumstances. This is currently one of the most
                  impactful book-to-tax difference items for R&D-intensive
                  partnerships.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Line 30 — Other Expense/Deduction Items With Differences:
                  </span>{' '}
                  A catch-all for any expense items with book-to-tax differences
                  not covered by specific lines. Commonly disclosed items here
                  include reserves, contingent liabilities, and comprehensive
                  income items. A required statement must be attached.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Line 31 – Total Expense/Deduction Items
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Combine the amounts from{' '}
                  <span style={{ fontWeight: 600 }}> lines 1 through 30</span>{' '}
                  and enter the total on{' '}
                  <span style={{ fontWeight: 600 }}> line 31</span>. Then report
                  the same amounts on{' '}
                  <span style={{ fontWeight: 600 }}> Part II, line 24</span>,
                  with the signs reversed:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Report{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      positive amounts as negative (in parentheses)
                    </span>
                    .
                  </li>
                  <li>
                    Report{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      negative amounts as positive
                    </span>
                    .{' '}
                  </li>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Example :</b> If{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    line 31, column (a) is $1,000,000,
                  </span>{' '}
                  report <span style={{ fontWeight: 600 }}>
                    ($1,000,000)
                  </span>{' '}
                  on{' '}
                  <span style={{ fontWeight: 600 }}>
                    Part II, line 24, column (a)
                  </span>
                  . If{' '}
                  <span style={{ fontWeight: 600 }}>line 31, column (b)</span>{' '}
                  is <span style={{ fontWeight: 600 }}>($50,000)</span>, report
                  <span style={{ fontWeight: 600 }}>$50,000</span> on{' '}
                  <span style={{ fontWeight: 600 }}>
                    Part II, line 24, column (b)
                  </span>
                  .
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="critical"
                >
                  Critical Tie-Outs: How Schedule M-3 Must Reconcile
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule M-3 is designed with specific mathematical tie-out
                  points that must be satisfied before a return is filed. Tax
                  professionals should verify these connections as part of every
                  Schedule M-3 review:
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Tie-Out Point
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            What Must Match
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>M-3 Part I, Line 11</TableCell>

                          <TableCell>
                            Must equal Schedule M-1, Line 1 (if M-1 is used in
                            lieu of Parts II and III){' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>M-3 Part II, Line 26, Column D</TableCell>

                          <TableCell>
                            Must equal Line 1 of the Analysis of Net Income
                            (Loss) on Form 1065{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>M-3 Part III, Line 31, Column A</TableCell>

                          <TableCell>
                            Must reconcile to total expense per the
                            partnership's income statement{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Column A totals (Parts II and III){' '}
                          </TableCell>

                          <TableCell>
                            Must reconcile to the partnership's standalone
                            income statement (M-3 Part I, Line 11){' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Column D totals </TableCell>

                          <TableCell>
                            Must reconcile to the taxable income items on{' '}
                            <Link
                              href="/resources/business-tax/schedule-k/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Schedule K
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  A return with Schedule M-3 tie-out failures will likely
                  generate an IRS correspondence notice and may be subject to
                  examination.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="schm3"
                >
                  Schedule M-3 vs. Schedule M-1: Side-by-Side Comparison
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Feature
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Schedule M-1
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Schedule M-3
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Who files </TableCell>
                          <TableCell>
                            Partnerships with assets $1M–$10M or receipts $250K+
                            (not filing M-3){' '}
                          </TableCell>

                          <TableCell>
                            Partnerships with $10M+ assets, $35M+ receipts, or
                            REP ownership  ‰¥50%
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Number of lines </TableCell>
                          <TableCell>9 summary lines </TableCell>

                          <TableCell>3 parts, 60+ detailed lines</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Column structure </TableCell>
                          <TableCell>None (single net amount) </TableCell>

                          <TableCell>
                            Four columns (A: book, B: temp, C: perm, D: tax)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Temporary vs. permanent</TableCell>
                          <TableCell>Not required to distinguish</TableCell>

                          <TableCell>Required for every line item</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Financial statement basis </TableCell>
                          <TableCell>Internal books </TableCell>

                          <TableCell>
                            GAAP, SEC filings, or other formal financial
                            statements
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>IRS audit exposure indicator </TableCell>
                          <TableCell>Moderate </TableCell>

                          <TableCell>
                            High — detailed and directly scrutinized{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Voluntary filing optio</TableCell>
                          <TableCell>N/A </TableCell>

                          <TableCell>
                            Yes — smaller partnerships may voluntarily file
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="division"
                >
                  Schedule M-3 and the IRS Large Business & International
                  Division
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule M-3 was developed in coordination with the IRS{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Large Business & International (LB&I) Division,
                  </span>{' '}
                  which is responsible for examining partnerships and
                  corporations with assets over $10 million. LB&I examiners
                  routinely use Schedule M-3 as a primary audit planning tool
                  because it provides a detailed, line-by-line map of every
                  difference between a partnership's financial reporting and its
                  tax return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Items that commonly attract LB&I attention on Schedule M-3
                  include:
                </Typography>
                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    Large amounts in Line 22 (Other Income Items) or Line 30
                    (Other Expense Items) without adequate supporting statements
                  </li>
                  <li>Reportable transactions on Part II, Line 10</li>
                  <li>
                    Significant permanent differences that reduce taxable income
                    substantially below book income
                  </li>
                  <li>
                    Inconsistencies between the M-3 amounts and the amounts
                    reported on related forms (Form 4562, Form 4797, Schedule D)
                  </li>
                  <li>
                    R&D cost treatment on Part III, Line 29 (particularly since
                    the 2022 Section 174 change)
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Maintaining detailed workpapers for every M-3 line — including
                  the source financial statement amounts, the rationale for each
                  Column B (temporary) and Column C (permanent) classification,
                  and the reconciliation to the tax return — is essential for
                  partnerships subject to Schedule M-3.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="schc"
                >
                  Schedule M-3 and Schedule C (Form 1065)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Some filers of Schedule M-3 are also required to complete
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule C (Form 1065)
                  </span>{' '}
                  to provide additional information. Schedule C is used by
                  partnerships that are part of a group that includes a
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Reportable Entity Partner{' '}
                  </span>{' '}
                  and applies to additional disclosure obligations created by
                  that relationship. Not all Schedule M-3 filers are required to
                  file Schedule C — only those where the REP relationship
                  triggers additional reporting under the IRS instructions.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="reportable"
                >
                  Reportable Entity Partner (REP): A Detailed Look
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The Reportable Entity Partner rule is one of the most
                  technically complex aspects of Schedule M-3 for partnerships.
                  A partner qualifies as a REP if it:
                </Typography>
                <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Owns or is{' '}
                    <span style={{ fontWeight: 600 }}>deemed to own</span>{' '}
                    (directly or indirectly) a{' '}
                    <span style={{ fontWeight: 600 }}>
                      50% or greater interest
                    </span>{' '}
                    in the partnership's income, loss, or capital on{' '}
                    <span style={{ fontWeight: 600 }}>any day</span> of the tax
                    year, AND
                  </li>
                  <li>
                    Was{' '}
                    <span style={{ fontWeight: 600 }}>
                      itself required to file Schedule M-3
                    </span>{' '}
                    with its most recently filed U.S. income tax or income
                    return filed{' '}
                    <span style={{ fontWeight: 600 }}>prior to that day</span>.
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}> Deemed ownership</span>{' '}
                  rules are broad. A parent corporation is deemed to own all
                  interests owned by its consolidated group members and by
                  entities in which it owns 50% or more by vote. This means a
                  large corporate group can trigger the REP rule for many
                  downstream partnerships even when no single entity directly
                  holds a 50% interest.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Notification requirement:
                  </span>{' '}
                  A REP must notify the partnership within{' '}
                  <span style={{ fontWeight: 600 }}> 30 days</span> of becoming
                  a REP that it qualifies as such. The partnership then has a
                  filing obligation for Schedule M-3 — regardless of whether it
                  would otherwise meet the asset or receipts thresholds. This
                  notification requirement makes it essential for partnership
                  administrators to monitor their partner roster for REP status
                  changes throughout the year.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="errors"
                >
                  Common Errors to Avoid on Schedule M-3
                </Typography>
                <Box component="ol" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Misclassifying temporary and permanent differences.
                    </span>{' '}
                    The most frequent M-3 error is incorrectly placing a
                    difference in Column B (temporary) when it belongs in Column
                    C (permanent), or vice versa. Goodwill impairment, fines and
                    penalties, and certain tax-exempt income are always
                    permanent. Depreciation and pension differences are almost
                    always temporary.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Leaving Line 22 or Line 30 blank without a required
                      statement.
                    </span>{' '}
                    The IRS requires a separate statement listing each item when
                    these catch-all lines are used. Filing without the required
                    statements is a common deficiency.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Failing to reconcile Column D to Schedule K.{' '}
                    </span>{' '}
                    Column D represents taxable amounts that must flow
                    consistently to{' '}
                    <Link
                      href="/resources/business-tax/schedule-k/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule K
                    </Link>{' '}
                    and{' '}
                    <Link
                      href="/resources/business-tax/schedule-k1-1065/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule K-1
                    </Link>
                    . Discrepancies between M-3 Column D and Schedule K are a
                    strong audit flag.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Not updating the Column A basis when financial statements
                      are restated.
                    </span>{' '}
                    If prior-period financial statements are restated, Line 3 of
                    Part I must reflect this, and Column A amounts must be
                    updated accordingly throughout Parts II and III.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Incorrectly applying the $50 million completion threshold.
                    </span>{' '}
                    Partnerships with less than $50 million in assets that
                    choose to complete only Part I and use M-1 for the remainder
                    must ensure M-1 Line 1 equals M-3 Part I, Line 11. Failing
                    to make this link is a common filing error.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Missing the REP notification.
                    </span>{' '}
                    Partnerships that fail to identify a Reportable Entity
                    Partner may inadvertently omit Schedule M-3 — exposing
                    themselves to late-filing penalties and potential
                    accuracy-related penalties.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Incorrect treatment of R&D costs under Section 174.
                    </span>{' '}
                    Since the Tax Cuts and Jobs Act change effective for tax
                    years beginning after December 31, 2021, R&D costs must be
                    capitalized and amortized for tax. Partnerships that
                    continue to deduct R&D fully in the year incurred
                    (consistent with prior law or GAAP) are reporting an error.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faq"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Does Schedule M-3 replace Schedule M-1 entirely?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Not always. Partnerships with less than $50 million in total
                  assets that are required to file M-3 (or voluntarily file it)
                  may complete only Part I of M-3 and use{' '}
                  <Link
                    href="/resources/business-tax/schedule-m-1/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule M-1
                  </Link>{' '}
                  for the remainder. Partnerships with $50 million or more must
                  complete M-3 entirely, in which case M-1 is not required.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. What financial statement basis should be used for Column A?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Column A should reflect the amounts from the partnership's
                  highest-priority financial statements, following the IRS order
                  of priority: SEC filings first, then certified audited GAAP
                  statements, then other non-tax-basis statements, then
                  tax-basis statements, and finally internal records where no
                  formal financial statements exist.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Is Schedule M-3 filed separately from Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  No. Schedule M-3 is attached to and filed as part of the
                  complete{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1065
                  </Link>{' '}
                  package. Partnerships required to file Schedule M-3 must use
                  the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Ogden, UT 84201-0011
                  </span>{' '}
                  mailing address if filing by paper, regardless of the
                  partnership's location.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Does a partnership with no book income still need to file
                  Schedule M-3?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, if the filing thresholds are met. A partnership that
                  meets the asset or receipts thresholds but reports a loss or
                  zero net income must still complete Schedule M-3 for the tax
                  year, since the filing requirement is based on size — not
                  profitability.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. What happens if a partnership does not file Schedule M-3
                  when required?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Failure to file a required Schedule M-3 is treated as an
                  incomplete Form 1065 filing, which can trigger the same
                  late-filing and accuracy-related penalties as failing to file
                  a complete return. The IRS may also select the return for
                  examination based on the missing schedule.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. Does voluntary filing of Schedule M-3 increase audit risk?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Not necessarily. Many partnerships voluntarily file M-3 for
                  reporting consistency within a corporate group. However, the
                  additional disclosure does give the IRS more detailed
                  information, so voluntary filers should ensure all M-3 amounts
                  are accurate and properly documented.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  7. How does Schedule M-3 interact with Schedule K-2 and K-3?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <Link
                    href="https://www.irs.gov/businesses/small-businesses-self-employed/form-1065-schedules-k-2-and-k-3-filing-requirements"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedules K-2 and K-3
                  </Link>{' '}
                  address international tax items and are a separate reporting
                  requirement from Schedule M-3. However, partnerships that file
                  Schedule M-3 and have international operations will typically
                  complete both. Items reported on K-2 and K-3 that have
                  book-to-tax differences must still be reflected in the
                  appropriate M-3 Part II or Part III lines.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 0.5,

                    lineHeight: 1.5,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key IRS Resources for Schedule M-3 (Form 1065)
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Resource
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Description
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Link
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Schedule M-3 (Form 1065) — Instructions{' '}
                          </TableCell>
                          <TableCell sx={{}}>
                            Official IRS instructions (November 2023)
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/instructions/i1065sm3"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov{' '}
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>Form 1065 (PDF)</TableCell>
                          <TableCell sx={{}}>
                            U.S. Return of Partnership Income
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f1065.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Download
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Instructions for Form 1065
                          </TableCell>
                          <TableCell sx={{}}>
                            Complete IRS filing instructions
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/instructions/i1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>About IRS Form 1065 </TableCell>
                          <TableCell sx={{}}>
                            IRS overview page with recent updates
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            IRS Publication 541 — Partnerships
                          </TableCell>
                          <TableCell sx={{}}>
                            Comprehensive partnership tax guide
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/publications/p541"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>Schedule C (Form 1065) </TableCell>
                          <TableCell sx={{}}>
                            Additional information for REP group filers
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Schedules K-2 and K-3 Filing Requirements
                          </TableCell>
                          <TableCell sx={{}}>
                            International reporting for partnerships
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/businesses/small-businesses-self-employed/form-1065-schedules-k-2-and-k-3-filing-requirements"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>
                            IRS Large Business & International Division{' '}
                          </TableCell>
                          <TableCell sx={{}}>
                            LB&I audit programs and resources
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/businesses/corporations/e-file-for-large-business-and-international-lbi"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready to e-file Form 1065 with accurate Schedule M-3
              reconciliation?
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure IRS compliance and avoid audit risks.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href="/business-tax/efile-irs-form-1065-online/"
              >
                Start E-filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default SchM3Form1065;
